//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as searchAction from '../action/searchAction';
//Icon
import ClearIcon from '@material-ui/icons/Clear';

class Comp extends React.Component {
	render() {
    let styleOuter = {
      position:'relative',
      display:'inline-block',
      margin:'2px',
      padding:'4px 6px',
      background:'rgba(0,0,0,0.6)',
      textAlign:'left',
      zIndex:'10',
      color:'#fff',
			borderRadius:'12px',
      fontSize:'0.8em',
      whiteSpace: 'nowrap',
    }

		let styleArrow = {
      position: 'absolute',
  		content: ' ',
  		top: '-12px',
  		left: '10px',
      marginLeft: '5px',
  		borderStyle: 'solid',
  		borderWidth: '0px 6px 12px 6px',
  		borderColor: 'transparent transparent rgba(0,0,0,0.6) transparent',
    }

		return (
      <div style={{position: 'absolute', left:'0px', bottom:'-45px'}}>
  			<div style={styleOuter}>
          <div style={styleArrow} />
					<div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent:'space-between',
            }}
          >
          	<div>検索条件はこちらから設定してください</div>
						&nbsp;
						<div>
							<ClearIcon
								style={{cursor:'pointer', fontSize:'1.4em', verticalAlign:'middle'}}
								onClick={ () => this.props.searchCondionButtonBalloonEdit(false) }
							/>
						</div>
					</div>
  			</div>
      </div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		ui: state.ui,
    search: state.search,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...searchAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
